var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPearhead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 409.032,
    height: 553.911,
    viewBox: "0, 0, 409.032, 553.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.996,470.874 L146.817,527.676 C146.817,527.676 135.117,534.356 133.457,539.37 C131.777,544.38 150.156,553.57 167.705,546.055 C185.235,538.535 194.434,473.379 194.434,473.379",
    fill: "#93C776",
    id: "path833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.996,470.874 L146.817,527.676 C146.817,527.676 135.117,534.356 133.457,539.37 C131.777,544.38 150.156,553.57 167.705,546.055 C185.235,538.535 194.434,473.379 194.434,473.379",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,470.874 L313.77,527.676 C313.77,527.676 325.449,534.356 327.129,539.37 C328.809,544.38 310.43,553.57 292.881,546.055 C275.332,538.535 266.152,473.379 266.152,473.379",
    fill: "#93C776",
    id: "path837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,470.874 L313.77,527.676 C313.77,527.676 325.449,534.356 327.129,539.37 C328.809,544.38 310.43,553.57 292.881,546.055 C275.332,538.535 266.152,473.379 266.152,473.379",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.336,428.267 C149.336,428.267 137.627,482.569 142.637,482.569 C147.656,482.569 213.643,486.738 216.152,485.904 C218.652,485.073 236.192,470.869 236.192,470.869 C236.192,470.869 246.231,486.738 249.561,488.408 C252.91,490.088 330.586,487.578 330.586,485.073 C330.586,482.569 321.387,432.446 321.387,432.446 L149.336,428.267",
    fill: "#EDB14E",
    id: "path841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.336,428.267 C149.336,428.267 137.627,482.569 142.637,482.569 C147.656,482.569 213.643,486.738 216.152,485.904 C218.652,485.073 236.192,470.869 236.192,470.869 C236.192,470.869 246.231,486.738 249.561,488.408 C252.91,490.088 330.586,487.578 330.586,485.073 C330.586,482.569 321.387,432.446 321.387,432.446 z",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.901,387.378 L341.553,398.384 L320.313,416.475 C320.313,416.475 316.387,437.7 323.467,445.567 C330.547,453.428 347.051,451.861 349.414,447.139 C351.777,442.422 347.051,429.053 347.051,429.053 C347.051,429.053 373.008,400.742 377.725,396.026 C382.442,391.309 361.211,367.715 361.211,367.715",
    fill: "#A2CC76",
    id: "path845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.901,387.378 L341.553,398.384 L320.313,416.475 C320.313,416.475 316.387,437.7 323.467,445.567 C330.547,453.428 347.051,451.861 349.414,447.139 C351.777,442.422 347.051,429.053 347.051,429.053 C347.051,429.053 373.008,400.742 377.725,396.026 C382.442,391.309 361.211,367.715 361.211,367.715",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.881,334.102 C22.881,334.102 48.242,364.18 68.291,335.869 C88.34,307.559 50.01,309.922 50.01,309.922 L22.881,334.102",
    fill: "#A2CC76",
    id: "path849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.881,334.102 C22.881,334.102 48.242,364.18 68.291,335.869 C88.34,307.559 50.01,309.922 50.01,309.922 z",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.178,293.013 C52.178,293.013 60.039,255.269 45.879,253.701 C30.235,251.963 30.938,285.156 31.729,291.445",
    fill: "#A2CC76",
    id: "path853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.178,293.013 C52.178,293.013 60.039,255.269 45.879,253.701 C30.235,251.963 30.938,285.156 31.729,291.445",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.461,313.853 C47.461,328.399 37.949,340.195 26.231,340.195 C14.502,340.195 5,328.399 5,313.853 C5,299.302 14.502,287.51 26.231,287.51 C37.949,287.51 47.461,299.302 47.461,313.853",
    fill: "#A2CC76",
    id: "path857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.461,313.853 C47.461,328.399 37.949,340.195 26.231,340.195 C14.502,340.195 5,328.399 5,313.853 C5,299.302 14.502,287.51 26.231,287.51 C37.949,287.51 47.461,299.302 47.461,313.853 z",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.606,322.11 C50.606,322.11 38.809,322.896 36.445,311.099 C34.082,299.302 49.824,296.162 56.895,296.944 C63.965,297.73 69.473,311.885 69.473,311.885 L117.442,333.906 L114.297,366.148 L60.039,344.912",
    fill: "#A2CC76",
    id: "path861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.606,322.11 C50.606,322.11 38.809,322.896 36.445,311.099 C34.082,299.302 49.824,296.162 56.895,296.944 C63.965,297.73 69.473,311.885 69.473,311.885 L117.442,333.906 L114.297,366.148 L60.039,344.912",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.356,338.628 C144.356,338.628 111.572,331.372 110.371,338.623 C109.16,345.874 104.395,379.151 108.008,377.94 C111.602,376.734 150.352,389.395 150.352,389.395 C150.352,389.395 137.139,431.699 144.356,432.905 C151.563,434.121 324.649,434.121 324.649,434.121 L316.24,382.139 C316.24,382.139 326.152,390.523 329.756,390.523 C333.369,390.523 366.397,364.326 362.783,358.281 C359.18,352.237 327.051,331.377 327.051,331.377",
    fill: "#546DA6",
    id: "path865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.356,338.628 C144.356,338.628 111.572,331.372 110.371,338.623 C109.16,345.874 104.395,379.151 108.008,377.94 C111.602,376.734 150.352,389.395 150.352,389.395 C150.352,389.395 137.139,431.699 144.356,432.905 C151.563,434.121 324.649,434.121 324.649,434.121 L316.24,382.139 C316.24,382.139 326.152,390.523 329.756,390.523 C333.369,390.523 366.397,364.326 362.783,358.281 C359.18,352.237 327.051,331.377 327.051,331.377",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.063,5 L241.699,5 L241.699,58.989 L224.063,58.989 z",
    fill: "#B79D5A",
    id: "path869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.063,5 L241.699,5 L241.699,58.989 L224.063,58.989 z",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.295,183.34 C301.68,162.71 315.235,128.399 298.164,82.403 C284.678,46.079 250.899,42.442 237.236,42.51 C237.041,42.505 236.797,42.51 236.602,42.51 C236.387,42.51 236.152,42.505 235.957,42.51 C222.305,42.442 188.516,46.079 175.039,82.403 C157.969,128.399 171.514,162.71 140.899,183.34 C112.442,202.505 63.037,232.588 69.766,290.674 C76.367,347.476 180.371,365.737 246.152,366.06 C311.934,366.377 396.826,347.476 403.418,290.674 C410.156,232.588 360.742,202.505 332.295,183.34",
    fill: "#A2CC76",
    id: "path873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.295,183.34 C301.68,162.71 315.235,128.399 298.164,82.403 C284.678,46.079 250.899,42.442 237.236,42.51 C237.041,42.505 236.797,42.51 236.602,42.51 C236.387,42.51 236.152,42.505 235.957,42.51 C222.305,42.442 188.516,46.079 175.039,82.403 C157.969,128.399 171.514,162.71 140.899,183.34 C112.442,202.505 63.037,232.588 69.766,290.674 C76.367,347.476 180.371,365.737 246.152,366.06 C311.934,366.377 396.826,347.476 403.418,290.674 C410.156,232.588 360.742,202.505 332.295,183.34 z",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.699,23.736 C241.699,23.736 281.367,-11.528 337.559,21.529 C337.559,21.529 295.684,72.212 241.699,23.736",
    fill: "#569C56",
    id: "path877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.699,23.736 C241.699,23.736 281.367,-11.528 337.559,21.529 C337.559,21.529 295.684,72.212 241.699,23.736 z",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.031,103.071 C202.031,107.935 198.076,111.885 193.203,111.885 C188.34,111.885 184.395,107.935 184.395,103.071 C184.395,98.198 188.34,94.258 193.203,94.258 C198.076,94.258 202.031,98.198 202.031,103.071",
    fill: "#8CAD5F",
    id: "path881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.871,149.351 C232.871,154.219 228.926,158.164 224.063,158.164 C219.199,158.164 215.244,154.219 215.244,149.351 C215.244,144.483 219.199,140.532 224.063,140.532 C228.926,140.532 232.871,144.483 232.871,149.351",
    fill: "#8CAD5F",
    id: "path883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.746,100.864 C274.746,105.733 270.801,109.683 265.938,109.683 C261.065,109.683 257.119,105.733 257.119,100.864 C257.119,95.996 261.065,92.051 265.938,92.051 C270.801,92.051 274.746,95.996 274.746,100.864",
    fill: "#8CAD5F",
    id: "path885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.305,190.122 C302.305,194.986 298.35,198.936 293.477,198.936 C288.613,198.936 284.668,194.986 284.668,190.122 C284.668,185.249 288.613,181.304 293.477,181.304 C298.35,181.304 302.305,185.249 302.305,190.122",
    fill: "#8CAD5F",
    id: "path887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.492,245.215 C239.492,250.083 235.547,254.029 230.674,254.029 C225.801,254.029 221.856,250.083 221.856,245.215 C221.856,240.347 225.801,236.397 230.674,236.397 C235.547,236.397 239.492,240.347 239.492,245.215",
    fill: "#8CAD5F",
    id: "path889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,226.485 C145.83,231.348 141.875,235.298 137.012,235.298 C132.149,235.298 128.194,231.348 128.194,226.485 C128.194,221.612 132.149,217.671 137.012,217.671 C141.875,217.671 145.83,221.612 145.83,226.485",
    fill: "#8CAD5F",
    id: "path891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.758,276.07 C101.758,280.933 97.803,284.883 92.93,284.883 C88.067,284.883 84.121,280.933 84.121,276.07 C84.121,271.196 88.067,267.256 92.93,267.256 C97.803,267.256 101.758,271.196 101.758,276.07",
    fill: "#8CAD5F",
    id: "path893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.981,300.308 C179.981,305.181 176.035,309.121 171.172,309.121 C166.309,309.121 162.354,305.181 162.354,300.308 C162.354,295.445 166.309,291.494 171.172,291.494 C176.035,291.494 179.981,295.445 179.981,300.308",
    fill: "#8CAD5F",
    id: "path895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.332,273.867 C205.332,278.731 201.387,282.681 196.514,282.681 C191.641,282.681 187.695,278.731 187.695,273.867 C187.695,268.994 191.641,265.049 196.514,265.049 C201.387,265.049 205.332,268.994 205.332,273.867",
    fill: "#8CAD5F",
    id: "path897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.207,325.654 C247.207,330.518 243.252,334.468 238.389,334.468 C233.516,334.468 229.57,330.518 229.57,325.654 C229.57,320.786 233.516,316.836 238.389,316.836 C243.252,316.836 247.207,320.786 247.207,325.654",
    fill: "#8CAD5F",
    id: "path899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.906,280.474 C308.906,285.342 304.961,289.292 300.098,289.292 C295.225,289.292 291.279,285.342 291.279,280.474 C291.279,275.606 295.225,271.66 300.098,271.66 C304.961,271.66 308.906,275.606 308.906,280.474",
    fill: "#8CAD5F",
    id: "path901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.02,289.292 C375.02,294.155 371.074,298.106 366.211,298.106 C361.338,298.106 357.393,294.155 357.393,289.292 C357.393,284.424 361.338,280.474 366.211,280.474 C371.074,280.474 375.02,284.424 375.02,289.292",
    fill: "#8CAD5F",
    id: "path903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.828,328.96 C318.828,333.828 314.883,337.774 310.01,337.774 C305.137,337.774 301.192,333.828 301.192,328.96 C301.192,324.092 305.137,320.142 310.01,320.142 C314.883,320.142 318.828,324.092 318.828,328.96",
    fill: "#8CAD5F",
    id: "path905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.688,253.862 C204.688,278.384 184.805,298.272 160.274,298.272 C135.752,298.272 115.869,278.384 115.869,253.862 C115.869,229.336 135.752,209.453 160.274,209.453 C184.805,209.453 204.688,229.336 204.688,253.862",
    fill: "#E77F97",
    id: "path907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.793,227.129 C154.277,230.44 151.221,235.039 145.977,237.388 C140.723,239.737 135.254,238.955 133.77,235.64 C132.285,232.324 135.352,227.725 140.596,225.381 C145.84,223.028 151.309,223.809 152.793,227.129",
    fill: "#FFFFFE",
    id: "path909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.578,253.862 C362.578,278.384 342.695,298.272 318.184,298.272 C293.652,298.272 273.77,278.384 273.77,253.862 C273.77,229.336 293.652,209.453 318.184,209.453 C342.695,209.453 362.578,229.336 362.578,253.862",
    fill: "#E77F97",
    id: "path911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.684,227.129 C312.168,230.44 309.121,235.039 303.867,237.388 C298.613,239.737 293.164,238.955 291.68,235.64 C290.195,232.324 293.242,227.725 298.496,225.381 C303.74,223.028 309.199,223.809 310.684,227.129",
    fill: "#FFFFFE",
    id: "path913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.27,218.228 C211.27,230.337 205.01,240.152 197.285,240.152 C189.561,240.152 183.301,230.337 183.301,218.228 C183.301,206.113 189.561,196.294 197.285,196.294 C205.01,196.294 211.27,206.113 211.27,218.228",
    fill: "#3C2C1E",
    id: "path915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.121,218.228 C289.121,230.337 282.871,240.152 275.137,240.152 C267.422,240.152 261.152,230.337 261.152,218.228 C261.152,206.113 267.422,196.294 275.137,196.294 C282.871,196.294 289.121,206.113 289.121,218.228",
    fill: "#3C2C1E",
    id: "path917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.951,260.44 L283.086,259.341 C283.086,259.341 276.504,311.978 231.563,310.332 C186.602,308.692 184.951,260.44 184.951,260.44",
    fill: "#E05659",
    id: "path919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.951,260.44 L283.086,259.341 C283.086,259.341 276.504,311.978 231.563,310.332 C186.602,308.692 184.951,260.44 184.951,260.44 z M187.432,165.625 L208.662,174.273 M281.797,164.058 L259.766,172.705",
    fillOpacity: 0,
    stroke: "#3C2C1E",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path921"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearhead);
export default __webpack_public_path__ + "static/media/pearhead.9fab60dd7cc523da4e71931bd4eb33e9.svg";
export { ForwardRef as ReactComponent };